import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';
import {
  CONFIRM_ALL_INVOICES,
  HAS_DELIVERY_FEE_ORDER,
  MARK_AS_PAID,
  DAILY_SALES_PURCHASES,
  MONTHLY_PURCHASES,
  MONTHLY_PURCHASES_LIST,
  MONTHLY_SALES,
  MONTHLY_SALES_LIST,
  PACK_LIST,
  PICK_LIST,
  WAREHOUSE_LIST,
  SEND_ORDER_UPDATE_EMAIL,
} from 'redux/constants';

const apiStates = [
  ...restApiStates(['orders'], 'order'),
  { type: HAS_DELIVERY_FEE_ORDER, name: 'deliveryFeeOrder' },
  { type: MARK_AS_PAID, name: 'order', update: 'orders' },
  { type: DAILY_SALES_PURCHASES, name: 'dailySalesPurchases' },
  { type: MONTHLY_PURCHASES, name: 'monthlyPurchases' },
  { type: MONTHLY_PURCHASES_LIST, name: 'monthlyPurchasesList' },
  { type: MONTHLY_SALES, name: 'monthlySales' },
  { type: MONTHLY_SALES_LIST, name: 'monthlySalesList' },
  { type: PACK_LIST, name: 'packList' },
  { type: PICK_LIST, name: 'pickList' },
  { type: WAREHOUSE_LIST, name: 'warehouseList' },
  { type: CONFIRM_ALL_INVOICES, name: 'confirmAllInvoices' },
  { type: SEND_ORDER_UPDATE_EMAIL, name: 'sendOrderUpdateEmail' },
];

const instantStates = [];
const storage = {};
const listValues = [
  'orders',
  'packList',
  'pickList',
  'warehouseList',
  'dailySalesPurchases',
  'monthlyPurchases',
  'monthlyPurchasesList',
  'monthlySales',
  'monthlySalesList',
];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
